import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0d0ce73e")
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Select Your Label Size", -1)
const _hoisted_3 = {
  key: 0,
  id: "modal-sizes-container"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = ["value", "id", "onInput"]
const _hoisted_6 = ["value", "id", "onInput"]
const _hoisted_7 = ["for"]
const _hoisted_8 = { id: "size-info" }
const _hoisted_9 = {
  key: 1,
  id: "modal-sizes-container"
}
const _hoisted_10 = ["id"]
const _hoisted_11 = ["value", "id", "onInput"]
const _hoisted_12 = ["value", "id", "onInput"]
const _hoisted_13 = ["for"]
const _hoisted_14 = { id: "size-info" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseSVG = _resolveComponent("CloseSVG")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.fadeTransition, "modal"])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["modal-body", _ctx.bounceTransition])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", {
            class: "close-svg",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, [
            _createVNode(_component_CloseSVG, { propId: 'sizes-modal-close' })
          ])
        ]),
        (_ctx.idxRef === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelSizes, (size, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "modal-sizes",
                  key: index,
                  id: size.toString()
                }, [
                  (size === _ctx.currentLabel.width)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        checked: "",
                        name: "labelSizeInput",
                        type: "radio",
                        value: size,
                        id: (index + 100).toString(),
                        onInput: ($event: any) => (_ctx.handleInput($event.target, size))
                      }, null, 40, _hoisted_5))
                    : (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        name: "labelSizeInput",
                        type: "radio",
                        value: size,
                        id: (index + 100).toString(),
                        onInput: ($event: any) => (_ctx.handleInput($event.target, size))
                      }, null, 40, _hoisted_6)),
                  _createElementVNode("label", {
                    for: (index + 100).toString(),
                    class: "label-option"
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("p", null, _toDisplayString(size), 1)
                    ])
                  ], 8, _hoisted_7)
                ], 8, _hoisted_4))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelSizes, (size, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "modal-sizes",
                  key: index,
                  id: size.toString()
                }, [
                  (size === _ctx.currentLabel.height)
                    ? (_openBlock(), _createElementBlock("input", {
                        key: 0,
                        checked: "",
                        name: "labelSizeInput",
                        type: "radio",
                        value: size,
                        id: (index + 100).toString(),
                        onInput: ($event: any) => (_ctx.handleInput($event.target, size))
                      }, null, 40, _hoisted_11))
                    : (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        name: "labelSizeInput",
                        type: "radio",
                        value: size,
                        id: (index + 100).toString(),
                        onInput: ($event: any) => (_ctx.handleInput($event.target, size))
                      }, null, 40, _hoisted_12)),
                  _createElementVNode("label", {
                    for: (index + 100).toString(),
                    class: "label-option"
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", null, _toDisplayString(size), 1)
                    ])
                  ], 8, _hoisted_13)
                ], 8, _hoisted_10))
              }), 128))
            ])),
        _createElementVNode("button", {
          "aria-label": "Change label size",
          class: "modal-select-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeLabelSize()))
        }, "Change Label Size")
      ], 2)
    ], 2)
  ]))
}